/* coin.js — full feature, theme-native (no layout hacks) */
window.__coin_version = "final-2025-10-22.full";

(function () {
  "use strict";

  // Guard against double include
  if (window.__kane_inited) return;
  window.__kane_inited = true;

  /* =======================
     CONFIG
  ======================= */
  var DEBUG        = false;            // toggle console logs (window.coin.debug(true))
  var STEP_TIMEOUT = 8000;             // ms allowed between keys before reset
  var TARGET       = "UUDDLRLRBA";     // Konami sequence
  function log(){ if (DEBUG) try{ console.info.apply(console, ["[kane]"].concat([].slice.call(arguments))); }catch(_){} }

  /* =======================
     AUDIO bootstrap (gesture unlock)
  ======================= */
  var __ctx = null;
  function __onFirstGesture() {
    try { if (!__ctx) __ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch(_) {}
    window.removeEventListener("keydown",     __onFirstGesture, true);
    window.removeEventListener("pointerdown", __onFirstGesture, true);
    window.removeEventListener("touchstart",  __onFirstGesture, true);
  }
  window.addEventListener("keydown",     __onFirstGesture, true);
  window.addEventListener("pointerdown", __onFirstGesture, true);
  window.addEventListener("touchstart",  __onFirstGesture, true);

  /* =======================
     HINT BAR (no positioning; uses theme’s tiny bar)
  ======================= */
  var hintEl = null, hintTxt = null, hintTimer = null, lastProgress = 0;

function getHintRefs() {
  const scope = document.querySelector('.section-header'); // sticky header container
  if (scope) {
    hintEl  = scope.querySelector('.horizontal-bar')  || hintEl;
    hintTxt = scope.querySelector('.horizontal-text') || hintTxt;
  }
  return !!(hintEl && hintTxt);
}


  function hintShow(){
    if (!getHintRefs()) return;
    hintEl.setAttribute("aria-hidden","false");
    // bar is always present visually; we just reveal text briefly
  }
  function hintHide(){
    if (!getHintRefs()) return;
    hintEl.setAttribute("aria-hidden","true");
    hintTxt.textContent = "";
    lastProgress = 0;
    clearTimeout(hintTimer);
  }

  function glyphFor(sym){
    switch(sym){
      case "U": return "↑";
      case "D": return "↓";
      case "L": return "←";
      case "R": return "→";
      case "B": return "B";
      case "A": return "A";
      default:  return sym;
    }
  }

  function hintRender(progress){
    if (!getHintRefs()) return;
    if (progress <= 0) { hintHide(); return; }
    var out = "";
    for (var i=0;i<progress;i++){ if (i) out += " "; out += glyphFor(TARGET[i]); }
    hintTxt.textContent = out;
    hintShow();
    clearTimeout(hintTimer);
    hintTimer = setTimeout(hintHide, 1500);
  }

  /* =======================
     POPUP (lazy refs each show)
  ======================= */
  function getRewardRefs(){
    var reward = document.getElementById("coin-reward");
    if (!reward) return null;
    return {
      reward:   reward,
      card:     reward.querySelector(".coin-card"),
      backdrop: reward.querySelector(".coin-backdrop"),
      code:     reward.dataset.discount || "",
      redirect: reward.dataset.redirect || "/"
    };
  }

  function hide(){
    var R = getRewardRefs(); if (!R) return;
    R.reward.classList.add("coin-hidden");
    R.reward.setAttribute("aria-hidden","true");
  }

  function show(){
    var R = getRewardRefs(); if (!R) return;

    var codeEl  = document.getElementById("coin-code");
    var applyEl = document.getElementById("coin-apply");
    var closeEl = document.getElementById("coin-close");

    var applyHref = "/discount/" + encodeURIComponent(R.code) + "?redirect=" + encodeURIComponent(R.redirect);
    if (codeEl)  codeEl.textContent = R.code;
    if (applyEl) applyEl.setAttribute("href", applyHref);

    R.reward.classList.remove("coin-hidden");
    R.reward.setAttribute("aria-hidden","false");

    // Close handlers (per-open, auto-removed)
    var onBackdrop = function(e){ if (e.target === R.reward || e.target === R.backdrop) { e.stopPropagation(); hide(); } };
    var onOutside  = function(e){ if (R.card && !R.card.contains(e.target)) { e.preventDefault(); e.stopPropagation(); hide(); } };
    var onClose    = function(e){ e.preventDefault(); e.stopPropagation(); hide(); };
    var onEsc      = function(e){ if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); hide(); } };

    R.reward.addEventListener("click", onBackdrop, { once:true, capture:true });
    R.reward.addEventListener("click", onOutside,  { once:true, capture:true });
    if (closeEl) closeEl.addEventListener("click", onClose, { once:true });
    document.addEventListener("keydown", onEsc, { once:true, capture:true });

    try { sessionStorage.setItem("c_found","1"); } catch(_) {}
    log("popup shown");
  }

  // Public API
  window.coin = {
    show: function(){ show(); },
    hide: hide,
    reset: function(){ input=""; lastTs=0; lastKeySym=""; lastKeyAt=0; lastProgress=0; try{ sessionStorage.removeItem("c_found"); }catch(_){ } hintHide(); window.__celebrating=false; },
    status: function(){ return { buffer: input, target: TARGET }; },
    debug: function(on){ DEBUG = !!on; }
  };

  /* =======================
     FANFARE (≈3s, chiptune)
  ======================= */
  function playVictoryFanfare() {
    try {
      var ctx = (typeof __ctx !== "undefined" ? __ctx : null);
      if (!ctx) return 0;

      var now = ctx.currentTime + 0.01;
      var master = ctx.createGain();
      master.gain.setValueAtTime(0.0001, now);
      master.connect(ctx.destination);

      var lp = ctx.createBiquadFilter();
      lp.type = "lowpass"; lp.frequency.value = 5200; lp.Q.value = 0.7;
      lp.connect(master);

      function note(freq, tStart, dur, vol){
        var o1 = ctx.createOscillator(), g1 = ctx.createGain();
        o1.type = "square";
        o1.frequency.setValueAtTime(freq, tStart);
        g1.gain.setValueAtTime(0.0001, tStart);
        g1.gain.linearRampToValueAtTime(vol, tStart + 0.015);
        g1.gain.linearRampToValueAtTime(vol*0.75, tStart + Math.max(0.06, dur*0.55));
        g1.gain.linearRampToValueAtTime(0.0001, tStart + dur);
        o1.connect(g1); g1.connect(lp);
        o1.start(tStart); o1.stop(tStart + dur + 0.05);

        var o2 = ctx.createOscillator(), g2 = ctx.createGain();
        o2.type = "square";
        o2.frequency.setValueAtTime(freq/2, tStart);
        g2.gain.setValueAtTime(0.0001, tStart);
        g2.gain.linearRampToValueAtTime(vol*0.35, tStart + 0.01);
        g2.gain.linearRampToValueAtTime(0.0001, tStart + dur);
        o2.connect(g2); g2.connect(lp);
        o2.start(tStart); o2.stop(tStart + dur + 0.05);
      }

      var t = now, GAP = 0.03;
      // Cheerful phrase (original)
      note(784,  t, 0.20, 0.80); t+=0.20+GAP; // G5
      note(880,  t, 0.20, 0.85); t+=0.20+GAP; // A5
      note(988,  t, 0.24, 0.90); t+=0.24+GAP; // B5
      note(1175, t, 0.32, 0.95); t+=0.32+GAP; // D6
      note(1047, t, 0.20, 0.88); t+=0.20+GAP; // C6
      note(1175, t, 0.22, 0.92); t+=0.22+GAP; // D6
      note(1319, t, 0.30, 0.98); t+=0.30+GAP; // E6
      note(1175, t, 0.22, 0.92); t+=0.22+GAP; // D6
      note(988,  t, 0.24, 0.88); t+=0.24+GAP; // B5
      note(784,  t, 0.36, 0.85); t+=0.36+GAP; // G5 sustain

      master.gain.linearRampToValueAtTime(0.65, now + 0.03);
      master.gain.setValueAtTime(0.65, t);
      master.gain.linearRampToValueAtTime(0.0001, t + 0.35);

      var totalSec = (t - now) + 0.35;
      var totalMs  = Math.ceil(totalSec * 1000);

      setTimeout(function(){ try{ lp.disconnect(); master.disconnect(); }catch(e){} }, totalMs + 150);
      return totalMs;
    } catch(e) { return 0; }
  }

  /* =======================
     CELEBRATION (Kirby shuffle → GREAT JOB!!!)
     Renders **inside #horizontal-text** and clips safely.
  ======================= */
  var __lastScootIdx = 0;

  function showCelebrationDance(a, b){
    // Accept (done) or (fanfareMs, done)
    var fanfareMs = 0, done = null;
    if (typeof a === 'number' && isFinite(a)) { fanfareMs = a; done = (typeof b === 'function' ? b : null); }
    else if (typeof a === 'function') { done = a; }

    if (!getHintRefs()) { if (done) done(); return; }

    clearTimeout(hintTimer);
    hintShow();
    window.__celebrating = true;

    // Poses
    var RIGHT="(>'-')>", LEFT="<('-'<)", FRONT="<('-')>";
    var STARS = ["✦","✧","✩","★","☆"];

    // Layout constants (monospace "cells")
    var STAGE_CH = 46;       // inner stage width; kept modest
    var CENTER   = 14;
    var OFF      = 7;

    // Timing
    var FRAME_MS        = 210;
    var TYPE_MS         = 90;
    var MIN_FINAL_HOLD  = 3400;
    var FINAL_TEXT      = 'GREAT JOB!!!';

    function buildScootPath(center, off){
      var frames = [];
      for (var x = center - off; x < center; x++) frames.push({ pose: RIGHT, x: x });
      for (var x = center; x <= center + off; x++) frames.push({ pose: RIGHT, x: x });
      for (var x = center + off - 1; x >= center; x--) frames.push({ pose: LEFT, x: x });
      for (var x = center - 1; x >= center - Math.min(2, off); x--) frames.push({ pose: LEFT, x: x });
      return frames;
    }

    var SCOOT = buildScootPath(CENTER, OFF);
    var SCOOT_FRAMES = SCOOT.length;

    // Wrap stage in a clipping box so it never causes horizontal overflow.
    function renderLineNoStars(pose, xCols){
      hintTxt.innerHTML =
        '<span style="display:inline-block;max-width:100%;overflow:hidden;white-space:nowrap;">' + // clip box
          '<span class="kStage" style="display:inline-block;width:' + STAGE_CH + 'ch;text-align:left;white-space:pre;">' +
            '<span style="display:inline-block;width:' + xCols + 'ch">&nbsp;</span>' +
            '<span class="kPose" style="display:inline-block;vertical-align:baseline;">' + pose + '</span>' +
          '</span>' +
        '</span>';
    }

    function renderScoot(stepIdx){
      __lastScootIdx = stepIdx;
      var step = SCOOT[stepIdx];
      renderLineNoStars(step.pose, step.x);
    }

    function slideToFinal(cb){
      var last = SCOOT[(typeof __lastScootIdx === 'number' ? __lastScootIdx : SCOOT_FRAMES-1)];
      var fromX = last ? last.x : CENTER - 1;
      var toX   = CENTER;
      (function step(x){
        var pose = (x < toX) ? RIGHT : (x > toX ? LEFT : FRONT);
        renderLineNoStars(pose, x);
        if (x === toX) return cb();
        setTimeout(function(){ step(x + (x < toX ? 1 : -1)); }, FRAME_MS);
      })(fromX);
    }

    function typeGreatJob(cb){
      var shown = 0, tick = 0;

      function renderTyped(typed, starSym){
        hintTxt.innerHTML =
          '<span style="display:inline-block;max-width:100%;overflow:hidden;white-space:nowrap;">' +
            '<span class="kStage" style="display:inline-block;width:' + STAGE_CH + 'ch;text-align:left;white-space:pre;">' +
              '<span style="display:inline-block;width:' + CENTER + 'ch"></span>' +
              '<span class="kPose" style="display:inline-block;vertical-align:baseline;">' + FRONT + '</span>' +
              '  ' + starSym + ' ' + typed + ' ' + starSym +
            '</span>' +
          '</span>';
      }

      (function typeTick(){
        var typed = FINAL_TEXT.slice(0, shown);
        var star  = STARS[tick % STARS.length];
        renderTyped(typed, star);

        shown++; tick++;
        if (shown <= FINAL_TEXT.length) return setTimeout(typeTick, TYPE_MS);

        // Hold with flicker
        var holdStart = Date.now();
        (function flickerDuringHold(){
          var star2 = STARS[Math.floor(Math.random()*STARS.length)];
          renderTyped(FINAL_TEXT, star2);
          if (Date.now() - holdStart < MIN_FINAL_HOLD) setTimeout(flickerDuringHold, 120);
          else cb();
        })();
      })();
    }

    var TYPE_TIME  = FINAL_TEXT.length * TYPE_MS;
    var SLIDE_TIME = 5 * FRAME_MS; // slideToFinal ≤ ~5 steps
    var FINAL_HOLD = MIN_FINAL_HOLD;

    var budgetForDance = (isFinite(fanfareMs) && fanfareMs > 0)
      ? Math.max(0, fanfareMs - (TYPE_TIME + SLIDE_TIME + FINAL_HOLD))
      : (SCOOT.length * FRAME_MS * 1.2); // fallback ~1.2 loops

    var danceFramesMax = Math.max(1, Math.floor(budgetForDance / FRAME_MS));
    var framesPlayed = 0;

    (function dance(stepIdx){
      renderScoot(stepIdx);
      framesPlayed++;
      if (framesPlayed >= danceFramesMax) {
        return slideToFinal(function(){ typeGreatJob(finish); });
      }
      var nextStep = (stepIdx + 1) % SCOOT_FRAMES;
      setTimeout(function(){ dance(nextStep); }, FRAME_MS);
    })(0);

    function finish(){
      hintHide();
      if (typeof done === "function") done();
    }
  }

  /* =======================
     KEYS
  ======================= */
  function normalize(e){
    var k = (e.key || "").toLowerCase();
    var kc = e.keyCode || e.which;
    if (!k && (kc===37||kc===38||kc===39||kc===40)) {
      if (kc===37) k="arrowleft"; if (kc===38) k="arrowup"; if (kc===39) k="arrowright"; if (kc===40) k="arrowdown";
    }
    if (k==="up") k="arrowup"; if (k==="down") k="arrowdown"; if (k==="left") k="arrowleft"; if (k==="right") k="arrowright";
    if (k==="b") return "B"; if (k==="a") return "A";
    if (k==="arrowup") return "U"; if (k==="arrowdown") return "D"; if (k==="arrowleft") return "L"; if (k==="arrowright") return "R";
    return "";
  }

  var input="", lastTs=0, lastKeySym="", lastKeyAt=0;

  function onKey(e){
    if (window.__celebrating) return; // ignore during celebration

    var t = e.target;
    if (t && (t.tagName==="INPUT" || t.tagName==="TEXTAREA" || t.isContentEditable)) return;
    if (e.type !== "keyup") return;

    var sym = normalize(e);
    if (!sym) return;

    // de-dupe rapid repeats
    var now = Date.now();
    if (sym === lastKeySym && now - lastKeyAt < 120) return;
    lastKeySym = sym; lastKeyAt = now;

    if (now - lastTs > STEP_TIMEOUT) input = "";
    lastTs = now;

    input += sym;
    if (input.length > 40) input = input.slice(-40);

    // progress for hint
    var progress = 0;
    for (var i=1;i<=TARGET.length;i++){
      if (input.slice(-i) === TARGET.slice(0,i)) progress = i;
    }
    if (progress > 0) {
      if (progress === 1 || progress > lastProgress) { hintRender(progress); lastProgress = progress; }
    } else if (lastProgress > 0) {
      hintHide();
    }

    // FULL MATCH
    if (input.endsWith(TARGET)) {
      log("secret sequence detected");
      try { sessionStorage.removeItem("c_found"); } catch(_) {}

      var fanfareMs = playVictoryFanfare();
      showCelebrationDance(fanfareMs, function(){
        show(); // open popup after the flourish
      });

      input = "";
    }
  }

  /* =======================
     INIT
  ======================= */
  function init(){
    // Don’t run on Shopify checkout/account
    if (location.pathname.startsWith("/checkout") || location.pathname.startsWith("/account")) return;


    // Require the tiny bar (killswitch-friendly) and popup
    var haveBar = getHintRefs();
    var havePopup = !!document.getElementById("coin-reward");

    if (!haveBar && !havePopup) { log("no bar/popup present; exiting"); return; }

    // Key handler (single attach)
    window.addEventListener("keyup", onKey, { capture:true, passive:true });

    log("init ok");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once:true });
  } else {
    init();
  }
})();
